export enum StatusEnum {
    Preliminary = 1,
    SentToSupplier = 2,
    ApprovedBySupplier = 3,
    RejectedBySupplier = 4,
    Active = 5,
    Scrapped = 6,
    PhasingOut = 8,
    SentToMultipleSuppliers = 99
}

export enum ErrorTypeEnum {
    NoError = 0,
    Info = 1,
    Warning = 2,
    Error = 3,
    Success = 4,
    Custom = 5
}

export enum LevelEnum {
    LevelOne = 1,
    LevelTwo = 2,
    LevelThree = 3,
    CommonMaterial = 99
}
export enum LevelIndexEnum {
    LevelOne = 0,
    LevelTwo = 1,
    LevelThree = 2,
    CommonMaterial = 3
}

export enum SupplierValidForEnum {
    SEU = 0,
    SPC = 1,
    SPC_SEU = 2
}

export enum ConflictTypeEnum
{
    NoConflict =0,
    LastUnitConflict = 1, // if conflict PI includes only one pru
    NormalUnitConflict = 2, //if conflict PI includes more then one pru
    DifferentLevelAssetsConflict = 3 //If Level1Code or Level1-Quantity values are different
}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/shared/enums.model.ts